import { extendTheme, theme as baseTheme } from '@chakra-ui/react';

import { getComponentStyleConfigs } from '../helpers/get-component-style-configs';
import { getTokens } from '../helpers/get-tokens';

export const dls = extendTheme(
  {
    name: 'dls',
    ...getTokens('dls'),
    components: getComponentStyleConfigs(
      [
        'Accordion',
        'ActionButton',
        'Avatar',
        'Button',
        'Checkbox',
        'Drawer',
        'DrawerBody',
        'DrawerCloseButton',
        'DrawerContent',
        'DrawerHeader',
        'DrawerOverlay',
        'FormLabel',
        'Heading',
        'Icon',
        'Input',
        'Link',
        'Modal',
        'ModalHeaderBar',
        'ModalOverlay',
        'Progress',
        'Radio',
        'Select',
        'Skeleton',
        'Spinner',
        'Text',
        'Textarea',
        'Tooltip',
      ],
      'dls'
    ),
  },
  {},
  baseTheme
);
